import { CFStatus } from "../../constants";
import { _sharedActionsConstantsSupport } from "./actions";

export const _sharedStateSupport = {
  mainGeneralQuestions: [],
  formSentStatus: CFStatus.PENDING
};

export const _sharedReducerSupport = (state, action) => {
  switch (action.type) {
    case _sharedActionsConstantsSupport.FETCH_CF_SUCCESS: {
      return { ...state, mainGeneralQuestions: action.data };
    }
    case _sharedActionsConstantsSupport.SEND_CF_STATUS: {
      return { ...state, formSentStatus: action.data };
    }
    default:
      return state;
  }
};

export default _sharedReducerSupport;
